module.exports = __webpack_public_path__ + "img/person.b3136781.svg";